import constants from '@/shared/Constants';

const { MAX_STRING_LENGTH } = constants;

export const truncateToMaxStringLength = (str: string) => {
  return str.slice(0, MAX_STRING_LENGTH);
};
